/*global angular*/
module.exports = ['$uibModal', '$transitions', 'settings', 'fancyboxService', function ($uibModal, $transitions, settings, fancyboxService) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./image.html'),
    replace: true,
    transclude: true,
    scope: {
      content: '=data',
      lightbox: '=?'
    },
    link: function (scope) {
      const getImageUrl = function (image) {
        if (image) {
          return settings.apisAndUrls.cachedApi + image.attachments.filter(o => o.type === 'ILLUSTRATION')[0].href;
        }
        return '';

      };

      scope.openLightbox = function () {
        let galleryImages = [];
        if (!scope.lightbox) {
          scope.lightbox = [scope.content];
        }
        galleryImages.push(getImageUrl(scope.content));
        scope.lightbox.forEach(function (image) {
          if (image.key !== scope.content.key) {
            galleryImages.push(getImageUrl(image));
          }
        });
        fancyboxService.fancyboxPlus()(
          galleryImages,
          {
            padding: 20,
            type: 'image',
            changeFade: 0,
            cyclic: true,
            changeSpeed: 0
            //centerOnScroll: true
          });
      };
    }
  };
}];




// WEBPACK FOOTER //
// ./web/js/module/visionText/js/image/image.js